<template>
  <div>
    <Alerta :plan="false" :backButton="true" />
    <div style="height: 60vh" class="d-flex">
      <div class="row w-100">
        <div class="col-md-2 d-flex align-items-center justify-content-center">
          <Stepper :planos="true" />
        </div>
        <div class="col-md-10 w-100" v-if="plans.length >= 1">
          <carousel :dots="false" :center="false" :nav="false" :items="2">
            <template slot="prev"
              ><span class="btn-prev"><i class="fa fa-caret-left"></i></span
            ></template>

            <template slot="next"
              ><span v-if="plans.length > 2" class="btn-next"
                ><i class="fa fa-caret-right"></i></span
            ></template>

            <template v-for="plan in plans">
              <div :key="plan.id" class="card" @click="setPlan(plan)">
                <span class="title">Plano {{ plan.nome }}</span>
                <template v-if="plan.id === 7">
                  <span class="price"
                    >R$ {{ (plan.valor_a_prazo / 12).toFixed(2) }} / mes</span
                  >
                  <div class="description">
                    <span
                      >*R$ {{ plan.valor_a_prazo.toFixed(2) }} na assinatura
                      anual com pagamento único em até 12X
                    </span>
                  </div>
                </template>
                <template v-else>
                  <span class="price"
                    >R$ {{ plan.valor_a_prazo.toFixed(2) }} / Mês</span
                  >
                </template>

                <div class="description">
                  <span>{{ plan.descricao }}</span>
                </div>
                <hr />
                <span class="price mt-0 c-black"
                  >TENHA ACESSO<br />
                  AO NOSSO ACERVO.</span
                >
                <ul class="mt-3 lista">
                  <li>JOGOS DO DIA</li>
                  <li>TORNEIOS E MARATORNAS</li>
                  <li>EDIÇÕES</li>
                </ul>
                <button @click="setPlan(plan)" class="px-5 py-2 btn">
                  SELECIONAR
                </button>
              </div>
            </template>
          </carousel>
        </div>
      </div>
    </div>

    <Alerta />
  </div>
</template>
<script>
import Stepper from "../components/Stepper";
import Alerta from "../components/AlertaPlano";
import carousel from "vue-owl-carousel";
import firebase from "firebase";
import decode from "jwt-decode";

export default {
  name: "planos",
  components: {
    Stepper,
    Alerta,
    carousel,
  },
  data: () => ({
    plans: [],
  }),
  created: function () {
    //firebase.analytics().setCurrentScreen("WEB_Plano");
  },
  mounted: async function () {
    this.$store.commit("loading", true);
    this.$store.commit("jogo", false);
    await this.$axios
      .get(`/jogo/planos`)
      .then((res) => res.data)
      .then((res) => {
        console.log("Esses sao os planos")
        console.log(res)
        console.log("RESPOSTA NA POSICAO 0")
        console.log(res[0])
        this.$store.commit("loading", false);
        localStorage.removeItem("abriuPagamento");
        console.log(this.$store.getters.logado);
        //console.log(decode(localStorage.getItem("t")).usr)
        if (this.$store.getters.logado) {
          if (decode(localStorage.getItem("t")).usr.plano.id != 4) {
            res = res.filter((item) => {
              if (item.id != 4) {
                return item;
              }
            });
          }
        }

        if (typeof res === "object") {
          this.plans = Object.entries(res).map((el) => el[1]);
        } else {
          this.plans = res;
        }
      });
  },
  methods: {
    setPlan: async function (plan) {
      await this.$store.commit("loading", true);
      await this.$store.commit("addItemInCart", {
        type: "plan",
        payload: plan,
      });
      this.analyticSubmit(plan);
      console.log("esse é o plano")
      console.log(plan);
      await this.$router.push({ path: "/assinatura/cadastro" });
      await this.$store.commit("loading", false);
    },
    analyticSubmit: function (plan) {
      try {
        firebase.analytics().logEvent("WEB_tela_plano", {
          id: plan.id,
          nome: plan.nome,
          valor_a_prazo: plan.valor_a_prazo,
        });
      } catch (error) {
        console.log("analytic plan error:", error);
      }
      try {
        this.$intercom.trackEvent("WEB_tela_planos");
      } catch (error) {
        console.log("analytycIntercom planos error:", error);
      }
    },
  },
};
</script>
<style scoped>
.card {
  margin: 0;
  background-color: white;
  border: none;
  padding: 15px 5px;
  box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  height: 55vh;
  width: 90%;
  margin: 10px 0px;
  font-size: 14px !important;
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: ease 1s;

}
.card:hover{
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.8);
}

.owl-next {
  position: absolute !important;
  right: 0;
  top: 0;
}

.slider {
  transition: ease 3s;
  position: relative;
}

.btn-next {
  position: absolute;
  top: calc(50% - 15px);
  right: 20px;
  color: black;
  background-color: #7a4e93;
  font-size: 30px;
  padding: 0px 20px;
  color: white;
  outline: 0;
  z-index: 9999;
  border: none;
  cursor: pointer;
}

.btn-prev {
  position: absolute;
  top: calc(50% - 15px);
  left: 0px;
  color: black;
  background-color: #7a4e93;
  font-size: 30px;
  padding: 0px 20px;
  z-index: 9999;
  color: white;
  outline: 0;
  border: none;
  cursor: pointer;
}

.next {
  transform: translateX(-40.3%);
}

.btn {
  border: none;
  background-color: #7a4e93;
  border-radius: 0;
  color: white;
  font-size: 15px;
}

.c-black {
  color: black !important;
  font-size: 1.3em !important;
  letter-spacing: 2px;
  font-weight: bold;
  line-height: 1.3em;
}

.title {
  font-size: 2.3em;
  text-transform: uppercase;
  color: #7a4e93;
  font-weight: bolder;
  text-align: center;
  margin-bottom: 10px;
}

.price {
  font-size: 1.8em;
  text-transform: uppercase;
  color: #7a4e93;
  font-weight: bold;
  letter-spacing: 1px;
  height: 50px;
  text-align: center;
}

.description {
  font-family: "Agency FB Regular";
  text-align: center;
  text-transform: uppercase;
  font-size: 1em;
  min-height: 30px !important;
  width: 100%;
}

.lista li {
  font-family: "Agency FB Regular" !important;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  line-height: 16px;
}

hr {
  width: 80%;
  background-color: black;
  padding: 1px;
  opacity: 0.1;
}
</style>